module.exports = __webpack_public_path__ + "img/tu3.4af9c480.png";